// eslint-disable-next-line import/no-unresolved
import {
  DeprecatedDropdown,
  DeprecatedDropdownButton,
  DeprecatedDropdownItem,
  DeprecatedDropdownMenu,
} from "@deere/fuel-react";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { ConfigContext } from "../../../../context/ConfigContext";
import { DealerAccountContext } from "../../../../context/DealerAccountContext";

const RPMMenu = ({ selected }: { selected?: boolean }) => {
  const { t } = useTranslation("common");
  const { dealerAccount } = useContext(DealerAccountContext);
  const accountId = dealerAccount?.id as string;
  const { PROPOSED_ORDERS_URL, JDPRISM_HOMEPAGE_URL } =
    useContext(ConfigContext);
  const theme = useTheme();
  const ExternalLinkIcon = (
    <OpenInNewIcon
      fontSize="small"
      sx={{
        marginLeft: theme.tokens.FuelSpacing3,
        position: "relative",
        top: theme.tokens.FuelSpacing1,
      }}
    />
  );

  const dropDownHoverStyle = {
    ".MenuItem-link:hover": {
      color: theme.tokens.FuelColorBrandPrimary,
      backgroundColor: theme.tokens.FuelColorAlertSuccessBackground,
      borderColor: `${theme.tokens.FuelColorAlertSuccessBorder} !important`,
    },
  };

  const dropDownItemStyle = {
    borderWidth: "0px 0px 0px 3px",
    borderStyle: "solid",
    borderColor: "transparent",
  };

  return (
    <DeprecatedDropdown>
      <DeprecatedDropdownButton
        variant="text"
        data-testid="rpm-drop-down"
        style={{
          padding: "20px 8px",
          color: theme.tokens.FuelColorGray600,
          borderRadius: "0px",
          ...(selected && {
            color: theme.tokens.FuelColorBrandPrimary,
            fontWeight: theme.tokens.FuelFontWeightSemibold,
            borderBottom: `3px solid ${theme.tokens.FuelColorBrandPrimary}`,
          }),
        }}
      >
        {t("header.navItem.rpm")}
      </DeprecatedDropdownButton>
      <DeprecatedDropdownMenu
        className="rpm-menu-dropdown"
        style={{ minWidth: "max-content" }}
      >
        <Box sx={dropDownHoverStyle}>
          <a
            href={`${PROPOSED_ORDERS_URL}&account=${accountId}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <DeprecatedDropdownItem
              style={dropDownItemStyle}
              data-testid="proposed-orders-dropdownitem"
            >
              {t("header.navItem.rpm.proposedOrders")}
              {ExternalLinkIcon}
            </DeprecatedDropdownItem>
          </a>
          <a
            href={`${JDPRISM_HOMEPAGE_URL}&account=${accountId}`}
            target="_blank"
            rel="noopener noreferrer"
            style={{ textDecoration: "none" }}
          >
            <DeprecatedDropdownItem
              style={dropDownItemStyle}
              data-testid="jdpo-prism-dropdownitem"
            >
              {t("header.navItem.rpm.jdpoPrismHomePage")}
              {ExternalLinkIcon}
            </DeprecatedDropdownItem>
          </a>
        </Box>
      </DeprecatedDropdownMenu>
    </DeprecatedDropdown>
  );
};

export default RPMMenu;
